import { _ } from '@icc/shared/helpers';

export enum Units {
    CM = 'cm',
    CU_FT = 'cu ft',
    DAG = 'dag',
    DM3 = 'dm3',
    DR = 'dr',
    FT = 'ft',
    G = 'g',
    GAL = 'gal',
    GR = 'gr',
    IN = 'in',
    KG = 'kg',
    LB = 'lb',
    M = 'm',
    M2 = 'm2',
    M3 = 'm3',
    MG = 'mg',
    MM = 'mm',
    OZ = 'oz',
    PAIR = 'pair',
    PCS = 'pcs',
    PCT = 'pct',
    SQ_IN = 'sq in',
    SQ_FT = 'sq ft',
    SQ_YD = 'sq yd',
    YD = 'yd',
    CU_YD = 'cu yd',
    L = 'l',
}

export const units = {
    [Units.CM]: {
        name: _('UNIT|cm.name'),
        short: _('UNIT|cm.short'),
        long: _('UNIT|cm.long'),
    },
    [Units.CU_FT]: {
        name: _('UNIT|cu ft.name'),
        short: _('UNIT|cu ft.short'),
        long: _('UNIT|cu ft.long'),
    },
    [Units.DAG]: {
        name: _('UNIT|dag.name'),
        short: _('UNIT|dag.short'),
        long: _('UNIT|dag.long'),
    },
    [Units.DM3]: {
        name: _('UNIT|dm3.name'),
        short: _('UNIT|dm3.short'),
        long: _('UNIT|dm3.long'),
    },
    [Units.DR]: {
        name: _('UNIT|dr.name'),
        short: _('UNIT|dr.short'),
        long: _('UNIT|dr.long'),
    },
    [Units.FT]: {
        name: _('UNIT|ft.name'),
        short: _('UNIT|ft.short'),
        long: _('UNIT|ft.long'),
    },
    [Units.G]: {
        name: _('UNIT|g.name'),
        short: _('UNIT|g.short'),
        long: _('UNIT|g.long'),
    },
    [Units.GAL]: {
        name: _('UNIT|gal.name'),
        short: _('UNIT|gal.short'),
        long: _('UNIT|gal.long'),
    },
    [Units.GR]: {
        name: _('UNIT|gr.name'),
        short: _('UNIT|gr.short'),
        long: _('UNIT|gr.long'),
    },
    [Units.IN]: {
        name: _('UNIT|in.name'),
        short: _('UNIT|in.short'),
        long: _('UNIT|in.long'),
    },
    [Units.KG]: {
        name: _('UNIT|kg.name'),
        short: _('UNIT|kg.short'),
        long: _('UNIT|kg.long'),
    },
    [Units.LB]: {
        name: _('UNIT|lb.name'),
        short: _('UNIT|lb.short'),
        long: _('UNIT|lb.long'),
    },
    [Units.M]: {
        name: _('UNIT|m.name'),
        short: _('UNIT|m.short'),
        long: _('UNIT|m.long'),
    },
    [Units.M2]: {
        name: _('UNIT|m2.name'),
        short: _('UNIT|m2.short'),
        long: _('UNIT|m2.long'),
    },
    [Units.M3]: {
        name: _('UNIT|m3.name'),
        short: _('UNIT|m3.short'),
        long: _('UNIT|m3.long'),
    },
    [Units.MG]: {
        name: _('UNIT|mg.name'),
        short: _('UNIT|mg.short'),
        long: _('UNIT|mg.long'),
    },
    [Units.MM]: {
        name: _('UNIT|mm.name'),
        short: _('UNIT|mm.short'),
        long: _('UNIT|mm.long'),
    },
    [Units.OZ]: {
        name: _('UNIT|oz.name'),
        short: _('UNIT|oz.short'),
        long: _('UNIT|oz.long'),
    },
    [Units.PAIR]: {
        name: _('UNIT|pair.name'),
        short: _('UNIT|pair.short'),
        long: _('UNIT|pair.long'),
    },
    [Units.PCS]: {
        name: _('UNIT|pcs.name'),
        short: _('UNIT|pcs.short'),
        long: _('UNIT|pcs.long'),
    },
    [Units.PCT]: {
        name: _('UNIT|pct.name'),
        short: _('UNIT|pct.short'),
        long: _('UNIT|pct.long'),
    },
    [Units.SQ_IN]: {
        name: _('UNIT|sq in.name'),
        short: _('UNIT|sq in.short'),
        long: _('UNIT|sq in.long'),
    },
    [Units.SQ_FT]: {
        name: _('UNIT|sq ft.name'),
        short: _('UNIT|sq ft.short'),
        long: _('UNIT|sq ft.long'),
    },
    [Units.SQ_YD]: {
        name: _('UNIT|sq yd.name'),
        short: _('UNIT|sq yd.short'),
        long: _('UNIT|sq yd.long'),
    },
    [Units.YD]: {
        name: _('UNIT|yd.name'),
        short: _('UNIT|yd.short'),
        long: _('UNIT|yd.long'),
    },
    [Units.CU_YD]: {
        name: _('UNIT|cu yd.name'),
        short: _('UNIT|cu yd.short'),
        long: _('UNIT|cu yd.long'),
    },
    [Units.L]: {
        name: _('UNIT|l.name'),
        short: _('UNIT|l.short'),
        long: _('UNIT|l.long'),
    },
};
